import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";

export const feedbackSlider = () => {
    const $feedback = document.querySelector(".section-feedbacks__row");
    const $feedbackRoot = $feedback.closest(".section-feedbacks");
    const $controls = $feedbackRoot.querySelector(".slider-controls");

    const swiper = new Swiper($feedback, {
        slidesPerView: 1,
        spaceBetween: 0,
        modules: [Navigation, Pagination],
        navigation: {
            prevEl: $feedback.querySelector(".section-feedbacks__prev"),
            nextEl: $feedback.querySelector(".section-feedbacks__next"),
        },
        pagination: {
            el: $controls.querySelector(".slider-controls__dots"),
            clickable: true
        }
    });
};